import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  selectPrefix,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setreportsFromDate,
  setreportsTodate,
} from "../../utility/Redux/profile";
import { FromToDate } from "../../utility/component/fromToDate";
import CustomerMasterHelp from "../../help/customermasterHelp";
import { GetSaleSummary } from "./func";
import { selectToken } from "../../utility/Redux/security";
import AccountMasterHelp from "../../help/listAccountMasterHelp";
import { SaleSummaryColumns } from "./columns";
import Footer from "./footer";
import { useReactToPrint } from "react-to-print";
import GeniusTableReports from "../../utility/component/geniusComponents/geniusTableData";
import ViewBillModal from "../../billing/viewBillModal";
import PrintWithFooter from "../../utility/component/datagrid/printReportWithFooter";
import GeniusTableForReports from "../../utility/component/printReport";

import { SaleSummaryPrintColumns } from "./printColumns";
import { SaleSummaryPrintTherminalColumns } from "./therminaColumns";
import IsLocalData from "../../utility/component/isLocalData";
import FromToDateMobile from "../../utility/component/fromToDateMobile";
import NewPrintReport from "../../utility/component/datagrid/newPrintReport";
import { FormatNumber2 } from "../../utility/functions/formatNumber";
import { CallAPIPromise } from "../../billing/common";
import VoucherPrint from "./paymodeSummaryPrint";

const SaleSummary = () => {
  const prefix = useSelector(selectPrefix);
  const [summaryList, setSummaryList] = useState([]);
  const [fullList, setFullList] = useState([]);
  const fromDate = useSelector(selectreportFromDate);
  const ToDate = useSelector(selectreportToDate);
  const width = useSelector(selectWidth);
  const [billHelpStatus, setBillhelpStatus] = useState(false);
  const [saleType, setSaleType] = useState("Retail");
  const [billNo, setBillNo] = useState("");
  const printRef = useRef(null);
  const paymodePrintRef = useRef();
  const [filterItem, setFilterItem] = useState("");
  const therminalRef = useRef(null);
  const PrintColumns = SaleSummaryPrintColumns(width);
  const therminalColoums = SaleSummaryPrintTherminalColumns(width);
  const [getCustomerData, setCustomerData] = useState({
    table_prefix: prefix,
    FDATE: moment(fromDate).format("YYYY-MM-DD"),
    TDATE: moment(ToDate).format("YYYY-MM-DD"),
    NAME: "",
    MOBILE: "",
    CUSTOMER_NAME: "",
    CUSTOMER_MOBILE: "",
  });
  const [paymodeSummary, setPaymodeSummary] = useState([]);
  const [paymodeprintStatus, setPaymodePrintStatus] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [paymodeType, setPaymodeType] = useState("All");
  const [isTaxHide, setIsTaxHided] = useState(true);
  const c = SaleSummaryColumns(width);
  const [columns, setColumns] = useState(c);

  const [customerHelpStatus, setCustomerHelpStatus] = useState(false);
  const [partyHelpStatus, setPartyHelpStatus] = useState(false);
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const okButton = (type = saleType) => {
    setSummaryList([]);
    setPaymodeType("All");
    GetSaleSummary(
      getCustomerData,
      token,
      dispatch,
      setSummaryList,
      type,
      filterItem,
      setFullList
    );
    CallAPIPromise("/api/saleReports/payModeSummary", {
      table_prefix: prefix,
      FDATE: fromDate,
      TDATE: ToDate,
    }).then((res) => {
      if (res.status === 200) {
        setPaymodeSummary(res.data.response);
      }
    });
  };
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    pageStyle: `
  @page {
    size: landscape;
  }
`,
  });
  useEffect(() => {
    setCustomerData((e) => {
      return {
        ...e,
        FDATE: moment(fromDate).format("YYYY-MM-DD"),
        TDATE: moment(ToDate).format("YYYY-MM-DD"),
      };
    });
  }, [fromDate, ToDate]);

  const isVoided = (I) => {
    if (saleType === "Retail") {
      const l = summaryList.filter(
        (s) => s.INVNO === I.INVNO && s.BILL_STATUS === "Void"
      );
      if (l[0]) {
        return {
          backgroundColor: "white",
          color: "red",
        };
      } else {
        return false;
      }
    } else {
      const l = summaryList.filter(
        (s) => s.INVNO === I.INVNO && s.BILL_STATUS === "Rejected"
      );
      if (l[0]) {
        return {
          backgroundColor: "white",
          color: "red",
        };
      } else {
        return false;
      }
    }
  };
  useEffect(() => {
    const callback = (details, data) => {
      setCustomerData({
        ...details[0],
        table_prefix: prefix,
      });
      setSummaryList(data);
      setFullList(data);
      dispatch(setreportsFromDate(details[0].FDATE));
      dispatch(setreportsTodate(details[0].TDATE));
    };
    const elseFunc = () => {
      console.log("nothing");
    };
    IsLocalData("sale_summary", callback, elseFunc);
  }, []);
  useEffect(() => {
    if (paymodeType) {
      setSummaryList(
        fullList.filter((f) => {
          if (paymodeType === "All") {
            return true;
          } else {
            if (paymodeType === "Cash") {
              return f.CASH_AMOUNT > 0;
            } else {
              if (paymodeType === "Card") {
                return f.CARD_AMOUNT > 0;
              } else {
                if (paymodeType === "BTC") {
                  return f.BTC_AMOUNT > 0;
                } else {
                  if (paymodeType === "EAMOUNT") {
                    return f.E_AMOUNT > 0;
                  } else {
                    if (paymodeType === "Void") {
                      return f.BILL_STATUS === "Void";
                    }
                  }
                }
              }
            }
          }
        })
      );
    }
  }, [paymodeType]);

  return (
    <div className=" bg-white flex flex-col h-full  overflow-y-auto ">
      <div className=" flex flex-col h-full p-3 ">
        <div>
          {window.innerWidth <= 764 ? (
            <FromToDateMobile
              maxWidth={"500px"}
              onPartyMasterSearchClick={() => {
                setPartyHelpStatus(true);
              }}
              onPrintClick={handlePrint}
              customerClear={() => {
                setCustomerName("");
                setCustomerData({
                  table_prefix: prefix,
                  FDATE: moment(fromDate).format("YYYY-MM-DD"),
                  TDATE: moment(ToDate).format("YYYY-MM-DD"),
                  NAME: "",
                  MOBILE: "",
                  CUSTOMER_NAME: "",
                  CUSTOMER_MOBILE: "",
                });
              }}
              partyClear={() => {
                setCustomerName("");
                setCustomerData({
                  table_prefix: prefix,
                  FDATE: moment(fromDate).format("YYYY-MM-DD"),
                  TDATE: moment(ToDate).format("YYYY-MM-DD"),
                  NAME: "",
                  MOBILE: "",
                  CUSTOMER_NAME: "",
                  CUSTOMER_MOBILE: "",
                });
              }}
              partyData={{
                NAME: getCustomerData.NAME,
                MOBILE: getCustomerData.MOBILE,
              }}
              onCustomerSearchClick={() => {
                setCustomerHelpStatus(true);
              }}
              customerData={{
                CUSTOMER_NAME: customerName,
                CUSTOMER_MOBILE: getCustomerData.CUSTOMER_MOBILE,
              }}
              submit={() => okButton(saleType)}
            />
          ) : (
            <>
              <FromToDate
                onPrintClick={handlePrint}
                hideReset={true}
                submit={() => okButton(saleType)}
                otherButton={
                  <div className="flex">
                    <div className="flex items-center">
                      <input
                        value={filterItem}
                        onChange={(e) => {
                          setFilterItem(e.target.value);
                        }}
                        placeholder="Filter by Item"
                        type="text"
                        className=" bg-gray-100 border text-sm outline-none px-2"
                      ></input>
                      <button
                        onClick={() => {
                          setFilterItem("");
                        }}
                        className="ml-3"
                      >
                        <i className="bi bi-x-lg text-red-500 flex items-center " />
                      </button>
                    </div>

                    {/* {width > 1400 &&
                      filterByPaymode(paymodeType, setPaymodeType)} */}
                  </div>
                }
              />
              <div className="mt-1">
                <FromToDate
                  hideDate={true}
                  onPartyMasterSearchClick={() => {
                    setPartyHelpStatus(true);
                  }}
                  customerClear={() => {
                    setCustomerName("");
                    setCustomerData({
                      table_prefix: prefix,
                      FDATE: moment(fromDate).format("YYYY-MM-DD"),
                      TDATE: moment(ToDate).format("YYYY-MM-DD"),
                      NAME: "",
                      MOBILE: "",
                      CUSTOMER_NAME: "",
                      CUSTOMER_MOBILE: "",
                    });
                  }}
                  partyClear={() => {
                    setCustomerName("");
                    setCustomerData({
                      table_prefix: prefix,
                      FDATE: moment(fromDate).format("YYYY-MM-DD"),
                      TDATE: moment(ToDate).format("YYYY-MM-DD"),
                      NAME: "",
                      MOBILE: "",
                      CUSTOMER_NAME: "",
                      CUSTOMER_MOBILE: "",
                    });
                  }}
                  otherButton={
                    paymodeSummary[0] && (
                      <button
                        onClick={() => {
                          setPaymodePrintStatus(true);
                        }}
                        className="flex items-center rounded-sm shadow-sm  ml-2 "
                        style={{
                          backgroundColor: "#93c5fd",
                          paddingLeft: 30,
                          paddingRight: 30,
                          paddingTop: 4,
                          paddingBottom: 4,
                          color: "black",
                          height: "32px",
                        }}
                      >
                        <i className="bi bi-printer pr-2"></i>
                        <div className="flex items-center text-sm">
                          Paymode Print
                        </div>
                      </button>
                    )
                  }
                  hideReset={true}
                  partyReset={() => {
                    setCustomerData((e) => {
                      return {
                        ...e,
                        table_prefix: prefix,
                        FDATE: moment(fromDate).format("YYYY-MM-DD"),
                        TDATE: moment(ToDate).format("YYYY-MM-DD"),
                        NAME: "",
                        MOBILE: "",
                      };
                    });
                    setCustomerName("");

                    setSummaryList([]);
                  }}
                  partyData={{
                    NAME: getCustomerData.NAME,
                    MOBILE: getCustomerData.MOBILE,
                  }}
                  onCustomerSearchClick={() => {
                    setCustomerHelpStatus(true);
                  }}
                  customerData={{
                    CUSTOMER_NAME: customerName,
                    CUSTOMER_MOBILE: getCustomerData.CUSTOMER_MOBILE,
                  }}
                />
              </div>
            </>
          )}
        </div>

        <div className="bg-[#e6e4e4] p-1 w-fit rounded-sm mt-2  flex">
          <button
            onClick={() => {
              setSaleType("Retail");
              okButton("Retail");
            }}
            className={`${
              saleType === "Retail" ? "bg-brown  text-white" : ""
            } py-1 px-5   rounded-sm flex-1 text-center`}
          >
            Summary
          </button>
          <button
            onClick={() => {
              setSaleType("Orders");
              okButton("Orders");
            }}
            className={`${
              saleType === "Orders" ? "bg-brown  text-white" : ""
            } py-1 px-5  rounded-sm flex-1 text-center`}
          >
            Orders
          </button>

          {filterByPaymode(paymodeType, setPaymodeType)}
          <div className="flex ml-2 items-center text-sm pr-4">
            <div className="flex items-center ml-3">
              <input
                type="checkbox"
                onChange={(e) => {
                  if (e.target.checked) {
                    setIsTaxHided(true);
                    setColumns(
                      c.filter((d) => {
                        return (
                          d.field !== "TAX1_RATE" &&
                          d.field !== "TAX2_RATE" &&
                          d.field !== "TAX3_RATE" &&
                          d.field !== "TAX1_AMT" &&
                          d.field !== "TAX2_AMT" &&
                          d.field !== "TAX3_AMT" &&
                          d.field !== "TOTAL"
                        );
                      })
                    );
                  } else {
                    setIsTaxHided(false);
                    setColumns(c);
                  }
                }}
                checked={isTaxHide}
                className="mr-1"
              />
              <div>Hide Tax Details</div>
            </div>
          </div>
        </div>
        {summaryList[0] ? (
          <div
            style={{
              height: `calc(100% - ${width <= 764 ? 220 : 170}px)`,
              width: "100%",
              marginTop: 10,
            }}
            className=" mb-2  "
          >
            <GeniusTableReports
              isVoided={isVoided}
              onRowDoubleClick={(row) => {
                const data = row.values;
                setBillNo(data.INVNO);
                setBillhelpStatus(true);
              }}
              data={summaryList}
              columns={columns}
              footer={<Footer columns={columns} rows={summaryList} />}
            />

            <div className="w-full mt-3 ">
              <div
                style={{
                  display: "none",
                }}
              >
                <div ref={printRef}>
                  <NewPrintReport
                    title={"Sale Summary"}
                    data={summaryList}
                    details={[
                      {
                        name: "From Date",
                        value: moment(fromDate).format("DD/MM/YYYY"),
                      },
                      {
                        name: "To Date",
                        value: moment(ToDate).format("DD/MM/YYYY"),
                      },
                      {
                        name: "Party Name",
                        value: getCustomerData.NAME,
                      },
                    ]}
                    columns={PrintColumns}
                    footer={
                      <Footer
                        isFeilds={
                          <div className="flex justify-end text-sm mt-2">
                            <div>
                              <div className="flex ">
                                <div className="font-semibold w-[160px] text-right ">
                                  Total Grant Total :
                                </div>
                                <div className="ml-2 flex flex-1 justify-end ">
                                  {FormatNumber2(
                                    summaryList.reduce(
                                      (acc, row) => acc + Number(row.GTOTAL),
                                      0
                                    )
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        columns={PrintColumns}
                        rows={summaryList}
                      />
                    }
                  />
                </div>
              </div>
            </div>
            <div className="w-full mt-3 ">
              <div
                style={{
                  display: "none",
                }}
              >
                <div ref={therminalRef}>
                  <GeniusTableForReports
                    customeHeader={
                      <div className="items-center ">
                        <div className="text-center ">Sale Summary</div>
                        <div className="flex items-center">
                          <div className="mr-1 text-sm font-semibold flex justify-center "></div>
                          <div className="text-sm font-semibold">From :</div>
                          <div className="ml-1 text-sm">
                            {moment(fromDate).format("DD-MM-YYYY")}{" "}
                          </div>
                          <div className="text-sm font-semibold ml-2">To :</div>
                          <div className="ml-1 text-sm">
                            {moment(ToDate).format("DD-MM-YYYY")}{" "}
                          </div>
                        </div>
                      </div>
                    }
                    data={summaryList}
                    columns={therminalColoums}
                    headerWidth={true}
                    marginTop={"120px"}
                    footer={
                      <Footer columns={therminalColoums} rows={summaryList} />
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="h-full flex justify-center items-center text-sm text-gray-400 border mt-3 rounded-sm">
            No Records Found
          </div>
        )}
      </div>
      <AccountMasterHelp
        onRowClick={(e) => {
          setCustomerData((c) => {
            return {
              ...c,
              NAME: e.row.NAME,
              MOBILE: "",
              CUSTOMER_NAME: "",
              CUSTOMER_MOBILE: "",
            };
          });
          setCustomerName("");

          setPartyHelpStatus(false);
        }}
        status={partyHelpStatus}
        onClose={() => {
          setPartyHelpStatus(false);
        }}
      />
      <CustomerMasterHelp
        onRowClick={(e) => {
          setCustomerData((c) => {
            return {
              ...c,
              CUSTOMER_NAME: "",
              CUSTOMER_MOBILE: e.row.CUSTOMER_MOBILE,
              NAME: "",
              MOBILE: "",
            };
          });
          setCustomerName(e.row.CUSTOMER_NAME);
          setCustomerHelpStatus(false);
        }}
        onClose={() => {
          setCustomerHelpStatus(false);
        }}
        status={customerHelpStatus}
      />
      <ViewBillModal
        bill_performa={saleType === "Retail" ? "bills" : "orders"}
        hideOrderSlip={true}
        setSummaryList={setSummaryList}
        status={billHelpStatus}
        billNo={billNo}
        onBack={() => setBillhelpStatus(false)}
      />
      <VoucherPrint
        paymodeSummary={paymodeSummary}
        status={paymodeprintStatus}
        fromDate={fromDate}
        ToDate={ToDate}
        onClose={() => {
          setPaymodePrintStatus(false);
        }}
      />
    </div>
  );
};

export default SaleSummary;
function filterByPaymode(paymodeType, setPaymodeType) {
  return (
    <div className="ml-[35px] pl-[35px] border-l flex items-center">
      <div className="pr-3 whitespace-nowrap">Filter By :</div>
      <select
        name="business_type"
        value={paymodeType}
        onChange={(e) => {
          setPaymodeType(e.target.value);
        }}
        className="border border-gray-300 rounded-md w-full py-1 outline-none "
      >
        <option>Select Paymode</option>
        {[
          {
            name: "All",
            value: "All",
          },
          {
            name: "Cash",
            value: "Cash",
          },
          {
            name: "Card",
            value: "Card",
          },
          {
            name: "BTC",
            value: "BTC",
          },
          {
            name: "EAMOUNT",
            value: "EAMOUNT",
          },
          {
            name: "Void",
            value: "Void",
          },
        ].map((c) => {
          return <option label={c.name} value={c.value} />;
        })}
      </select>
    </div>
  );
}
